// The "Positions and career" tab of a public figure's page (15 October 2026).
export default {
  titre: 'Positions, topic by topic',
  echelle: 'Position scale',
  depuis: 'since {jour}',
  change: 'Changed position on {le}: {avant}, then {position}',
  frise: 'Successive positions on this topic',
  chargement: 'Loading positions…',
  vide: 'No position recorded yet: they appear when this public figure speaks out on a topic',
}
